import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PrescriptionsPage } from './prescriptions';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    PrescriptionsPage,
  ],
  imports: [
    IonicPageModule.forChild(PrescriptionsPage),
    DirectivesModule
  ],
})
export class PrescriptionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/prescriptions/prescriptions.module.ts